/*
=========================================================
* Material Kit 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";

// Material Kit 2 PRO React examples
import DefaultInfoCard from "components/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "components/Cards/BlogCards/CenteredBlogCard";

// Image of Jonathan
import jonathan from "assets/images/jonathan.jpg";

function Information() {
    return (
        <MKBox component="section" py={12} mx={-2} container item borderRadius="md" shadow="md">
            <Container>
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} lg={6}>
                        <Grid container justifyContent="flex-start">
                            <Grid item xs={12} md={6}>
                                <MKBox mb={5}>
                                    <DefaultInfoCard
                                        icon="computer"
                                        color="primary"
                                        title="IT Professional"
                                        description="10+ years of Systems and Network Administration experience you can trust!"
                                    />
                                </MKBox>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <MKBox mb={5}>
                                    <DefaultInfoCard
                                        icon="auto_fix_high"
                                        color="primary"
                                        title="Linux Wizard"
                                        description="Dabbling in Custom APIs, Bash Scripting, System Tweaks, and teaching others how to be a good linux sys admin by never running their apps as root!"
                                    />
                                </MKBox>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <MKBox mb={{ xs: 5, md: 0 }}>
                                    <DefaultInfoCard
                                        icon="handshake"
                                        color="primary"
                                        title="Community Contributor"
                                        description="From helping Stargaze get a DefiLlama adapter created or helping Jackal setting up their archive RPC/API and troubleshooting the big block missing issue."
                                    />
                                </MKBox>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <MKBox mb={{ xs: 5, md: 0 }}>
                                    <DefaultInfoCard
                                        icon="build"
                                        color="primary"
                                        title="User Friendly Tools"
                                        description="Track your wallet, watch unbonds or other stats or use the simple explorer I provide for all to use!"
                                    />
                                </MKBox>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
                        <CenteredBlogCard
                            image={jonathan}
                            title="Erialos | Jonathan"
                            description="Pronouced AIR-E-AL-OUS, Jonathan has decades of field experience in IT as a Network and Systems Administrator."
                            action={{
                                type: "internal",
                                route: "/AboutMe",
                                color: "primary",
                                label: "Read More...",
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default Information;
